import { useCallback } from 'react';
import _ from 'lodash';

export default function useDebounceWithMemoizedCallback(
  funcToDebounce = () => {},
  timeoutSize = 1500,
) {
  return useCallback(_.debounce(funcToDebounce, timeoutSize), [funcToDebounce, timeoutSize]);
}
